/**
 * Configuration object to handle application options.
 *
 * @object config
 */
var config = {

  keys: {
    "SPACE": 32,
    "RETURN": 13,
    "TAB": 9,
    "ESC": 27,
    "LEFT": 37,
    "UP": 38,
    "RIGHT": 39,
    "DOWN": 40,
  },

};
